const getMedicalSpecialtyClass = (specialtyId) => {
	switch (specialtyId) {
		case 36:
			return 'orthopedics'
		case 53:
			return 'damage-evaluation'
		case 25:
			return 'general-family-medicine'
		default:
			return 'other'
	}
}
export default getMedicalSpecialtyClass
